module.exports = __webpack_public_path__ + "static/media/UKR.c886c71c.svg";